import React from 'react';
import { ReportEditTemplate } from 'themes/modules/report/pages';
import { ReportEditViewStore } from 'modules/report/stores';
import { setCurrentView } from 'core/utils';

@setCurrentView(rootStore => new ReportEditViewStore(rootStore), 'reportEditViewStore')
class ReportEdit extends React.Component {
	constructor(props) {
		super(props);
	}

	render() {
		return <ReportEditTemplate {...this.props} />;
	}
}

export default ReportEdit;
